import React from 'react';
import { User, Box, FileText, Settings, Heart } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const NavItem = ({ icon, text, active = false, onClick }) => {
  return (
    <div
      className={`flex items-center gap-2 py-2 px-4 cursor-pointer hover:bg-gray-200 transition-colors ${
        active ? "border-l-2 border-black bg-gray-100" : ""
      }`}
      onClick={onClick}
    >
      <div className="text-gray-700">{icon}</div>
      <span className="text-sm">{text}</span>
    </div>
  );
};

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  return (
    <div className="h-full w-full bg-gray-50 border-r border-gray-200">
      <div className="p-4 border-b border-gray-200">
        <div className="text-sm font-medium text-gray-500">System / Llogaria ime</div>
      </div>
      <div className="py-4">
        <NavItem 
          icon={<User size={18} />} 
          text="Llogaria ime" 
          active={path === '/settings'} 
          onClick={() => navigate('/settings')}
        />
        <NavItem 
          icon={<Box size={18} />} 
          text="Porositë" 
          onClick={() => navigate('/settings')}
        />
        <NavItem 
          icon={<Heart size={18} />} 
          text="Lista e dëshirave" 
          active={path === '/wishlist'} 
          onClick={() => navigate('/wishlist')}
        />
        <NavItem 
          icon={<Settings size={18} />} 
          text="Mënyra e pageses" 
          onClick={() => navigate('/settings')}
        />
      </div>
    </div>
  );
};

export default Sidebar;